import VueCarousel from 'vue-carousel';

export default ({ app, router, Vue }) => {
  Vue.use(VueCarousel)
}
